<template>
  <CustomRow>
    <v-card class="py-10 my-5 font-weight-bold" :class="breakpointPadding">
      <div class="text-title" :class="breakpointPadding">
        {{ $t(`order_done_text_title${campaign.isLottery ? "_lottery" : ""}`) }}
      </div>
      <template v-if="orderInfoRes.transType == 'ATM'">
        <div class="text-title" :class="breakpointPadding">
          {{ $t("order_done_content_1") }}
          <span class="red--text">{{
            orderInfoRes.atmPaymentDeadline || "-"
          }}</span>
          {{ $t("order_done_content_2") }}<br /><br />
        </div>
        <div class="text-page-title" :class="breakpointPadding">
          {{ $t("order_done_bank_code") }}&emsp;<span class="primary-1--text">{{
            orderInfoRes.bankCode || "-"
          }}</span>
          <br />
          {{ $t("orderlist_bank_account") }}&emsp;<span
            class="primary-1--text"
            >{{ orderInfoRes.atmAccount || "-" }}</span
          >
        </div>
      </template>
      <div class="text-page-title" :class="breakpointPadding">
        <br />
        {{
          $t(`order_done_order_no${campaign.isLottery ? "_lottery" : ""}`)
        }}#{{ orderInfoRes.orderNum || "-" }}
      </div>
      <div
        class="bg-tranparent-yellow py-3 mt-2 text-page-title"
        :class="breakpointPadding"
      >
        {{ orderInfoRes.sessionName || "-" }}
      </div>
      <div
        class="order-detail px-2 py-3"
        v-if="!!orderInfoRes.seatInfo && orderInfoRes.seatInfo.length"
      >
        <div class="px-4">
          <span class="primary-1--text d-inline-block valign-top">{{
            $t(`order_done_seat${campaign.isLottery ? "_lottery" : ""}`)
          }}</span
          >&emsp;
          <span class="d-inline-block">
            <div v-for="(seat, i) of orderInfoRes.seatInfo" :key="`seat-${i}`">
              {{ seat }}
            </div>
          </span>
        </div>
      </div>
      <div class="order-detail px-2 py-3" v-if="!campaign.isLottery">
        <div class="px-4">
          <span class="primary-1--text">{{ $t("orderlist_get_type") }}</span
          >&emsp;{{ pickupTypeText() }}
        </div>
        <div class="red-dash-divider my-3" />
        <div class="px-4">
          <span class="primary-1--text">{{ $t("orderlist_payment") }}</span
          >&emsp;{{ transTypeText() }}
        </div>
        <div class="red-dash-divider my-3" />
        <div class="px-4">
          <span class="primary-1--text">{{ $t("order_done_price") }}</span
          >&emsp;{{ formatTotal() }}
        </div>
        <div class="red-dash-divider my-3" />
        <div class="px-4">
          <span class="primary-1--text">{{ $t("orderlist_receipt") }}</span
          >&emsp;{{ receiptTypeText() }}
        </div>
      </div>
      <div class="text-center mt-10">
        <v-btn
          outlined
          color="primary-1"
          rounded
          depressed
          class="font-weight-bold mx-auto"
          style="border: 2px solid"
          @click="$router.push({ name: 'OrderList' })"
        >
          {{
            $t(
              `order_done_order_detail_cta${
                campaign.isLottery ? "_lottery" : ""
              }`
            )
          }}
        </v-btn>
      </div>
    </v-card>
  </CustomRow>
</template>

<script>
import { orderCheckLoginMixins } from "@/shared/mixins";
import OM from "@/api/order-management";
import { mapGetters, mapActions } from "vuex";
import { initGtag } from "@/shared/utils";

export default {
  mixins: [orderCheckLoginMixins],
  data() {
    return {
      ccPay: true,
      orderInfoRes: {},
    };
  },
  metaInfo() {
    return {
      title: `${this.$t("order_done_title")} | ${this.$t("app_name")}`,
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: `${this.$t("order_done_title")} | ${this.$t("app_name")}`,
            url: window.location.href,
          },
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      campaign: "event/campaign",
    }),
    breakpointPadding() {
      if (this.$vuetify.breakpoint.xs) return "px-5";
      if (this.$vuetify.breakpoint.sm) return "px-5";
      return "px-8";
    },
  },
  async mounted() {
    this.resetCountdown();
    let { data: getOrderInfoRes } = await OM.getPurchaseInfo(
      this.$route.params.orderId
    );
    if (getOrderInfoRes.errCode == "00") {
      this.orderInfoRes = getOrderInfoRes;
    }
    this.$gtm.trackView(
      `Done：${this.orderInfoRes.sessionName}`,
      this.$route.path
    );
    if (this.campaign.gaId) {
      initGtag(this.campaign.gaId);
    }
  },
  methods: {
    ...mapActions({
      resetCountdown: "order/resetCountdown",
    }),
    pickupTypeText() {
      let str = "";
      switch (this.orderInfoRes.shippingType) {
        case "serial":
          str = this.$t("orderlist_serial_pickup");
          break;
        case "famiport":
          str = this.$t("orderlist_fami_pickup");
          break;
        case "ibon":
          str = this.$t("orderlist_ibon_pickup");
          break;
        case "post":
          str = this.$t("orderlist_post_pickup");
          break;
        case "eTicket":
          str = this.$t("eticket");
          break;
        case "none":
          str = this.$t("orderlist_no_pickup");
          break;
        default:
          str = "-";
      }
      return str;
    },
    transTypeText() {
      let str = "";
      switch (this.orderInfoRes.transType) {
        case "ATM":
          str = this.$t("orderlist_virtual_account");
          break;
        case "CC":
          str = this.$t("orderlist_card_payment_one_time");
          break;
        default:
          str = "-";
      }
      return str;
    },
    receiptTypeText() {
      let str = "";
      switch (this.orderInfoRes.receiptType) {
        case "donate":
          str = this.$t("orderlist_donate_receipt");
          break;
        case "duplicate":
          str = this.$t("orderlist_personal_receipt");
          break;
        case "triplicate":
          str = this.$t("orderlist_corp_receipt");
          break;
        default:
          str = "-";
      }
      return str;
    },
    formatTotal() {
      if (this.orderInfoRes.totalAmount)
        return `NT.${this.orderInfoRes.totalAmount
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
      return "-";
    },
  },
  beforeRouteLeave(to, from, next) {
    console.log("beforeRouteLeave", to, this.orderInfoRes);
    if (to.name === "Order3") {
      next(false);
      this.$router.push({
        name: "Order1",
        params: { eventId: to.params.eventId, sessionId: to.params.sessionId },
      });
      return false;
    }

    next();
  },
};
</script>

<style lang="scss" scoped>
.order-detail {
  border: 1px solid $grey-1;
  margin: 20px 0;
  border-radius: $radiusDesktop !important;

  @media screen and (max-width: 768px) {
    border-radius: $radiusMobile !important;
  }
}
</style>
